<template>
  <v-container fluid class="list-users">
    <v-row class="flex-grow-0">
      <h3>{{ $t('app_drawer.users') }}</h3>
      <v-btn color="primary"
             class="ml-4"
             small
             :to="{name: 'user-create'}">
        <v-icon>mdi-plus</v-icon>
        New
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <UserList full-height
                  :refresh-trigger.sync="refreshTrigger"></UserList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import UserList from "@/components/user/UserList";

export default {
  name: 'Users',
  components: {UserList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    return {
      refreshTrigger,
      refresh,
    }
  }
}
</script>

<style lang="less">
.list-users {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
